import { FC, PropsWithChildren } from 'react';

import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  BenefitText,
  Container,
  ContentText,
  InfoBadge,
  InfoContainer,
  InfoText,
  SectionTitle,
  StyledImage,
  Title,
} from './styled';

const walmartMembershipImg = require('./walmart-membership-image.png');

type WalmartMembershipProps = {
  title?: string;
};

export const WalmartMembership: FC<PropsWithChildren<WalmartMembershipProps>> = ({ title }) => {
  const enableWalmartPlusMonthlyTrialOffer = useFlag(
    LaunchDarklyFlag.ENABLE_WALMART_PLUS_TRIAL_OFFER_MONTHLY
  );

  const text: Record<string, TranslationKey> = enableWalmartPlusMonthlyTrialOffer
    ? {
        sectionTitle: 'dontHaveWalmartAccountMonthly',
        contentText: 'walmartMembershipSignUpMonthly',
        infoText: 'walmartMembershipDealMonthly',
      }
    : {
        sectionTitle: 'dontHaveWalmartAccount',
        contentText: 'walmartMembershipSignUp',
        infoText: 'walmartMembershipDeal',
      };

  return (
    <>
      <SectionTitle>{title || t(text.sectionTitle)}</SectionTitle>
      <Container>
        <StyledImage source={walmartMembershipImg} />
        <Title>{t('royalPerksMembersEnjoy')}</Title>
        <BenefitText>{t('walmartPlusBenefit')}</BenefitText>
        <ContentText>{t(text.contentText)}</ContentText>
        <InfoContainer>
          <InfoBadge>
            <InfoText>{t(text.infoText)}</InfoText>
          </InfoBadge>
        </InfoContainer>
      </Container>
    </>
  );
};
